import moment from "moment";

const timeOptionsMapper = {
    /**
     * Return array of time options for given day and place
     * @param {Object} date
     * @param {Object} place
     * @return {Array}
     */
    mapTimeOptions: function (date, place) {
        let now = moment();
        let isToday = date.isSame(now, "day");
        let options = [];

        if (!place.openingHours) {
            return options;
        }

        let dayName = date.locale("en").format("dddd");
        let minTime = place.openingHours[dayName.toLowerCase()].from;
        if (isToday) {
            let minTimeInstance = now.add(15, 'minutes');
            let roundedMinutes = Math.ceil(minTimeInstance.minutes() / 5) * 5;
            minTimeInstance.minutes(roundedMinutes).seconds(0);
            minTime = minTimeInstance.format("HH:mm");
        }
        let maxTime = place.openingHours[dayName.toLowerCase()].to;
        if (!minTime || !maxTime) {
            return options;
        }
        let startHour = parseInt(minTime.slice(0, 2));
        let endHour = parseInt(maxTime.slice(0, 2));
        for (let i = startHour; i < endHour; i++) {
            for (let j = 0; j < 60; j += 5) {
                let timeSlot =
                    String(i).padStart(2, "0") +
                    ":" +
                    String(j).padStart(2, "0");
                let option = {
                    text: timeSlot,
                    value: timeSlot,
                };
                options.push(option);
            }
        }
        return options;
    },
};

export default timeOptionsMapper;
